/**
 * Schemas Zod compartilhados para a busca interna (Fase 5.5).
 *
 * O endpoint `GET /search` normaliza resultados de 4 tabelas em um shape
 * único discriminado por `tipo`. O site público usa o mesmo schema para
 * tipar o fetch + renderizar grupos.
 */
import { z } from 'zod';

export const searchTipoSchema = z.enum(['article', 'content_page', 'glossary', 'project']);
export type SearchTipo = z.infer<typeof searchTipoSchema>;

/**
 * Resultado normalizado.
 *   - `tipo`: discriminador (artigo, página, termo, projeto)
 *   - `url`: caminho relativo no site público (`/publicacoes/<slug>` etc.)
 *   - `snippet`: trecho com matches (resumo cru, sem `<mark>` por enquanto;
 *     a UI pode aplicar highlight client-side se quiser)
 *   - `score`: rank do `ts_rank` para ordenação global
 */
export const searchResultSchema = z.object({
  tipo: searchTipoSchema,
  titulo: z.string().min(1).max(280),
  slug: z.string().min(1).max(200),
  url: z.string().min(1).max(300),
  snippet: z.string().max(500).nullable(),
  score: z.number(),
});
export type SearchResult = z.infer<typeof searchResultSchema>;

export const searchQuerySchema = z.object({
  q: z.string().min(1).max(120),
  limit: z.coerce.number().int().min(1).max(50).default(10),
  offset: z.coerce.number().int().min(0).max(500).default(0),
});
export type SearchQuery = z.infer<typeof searchQuerySchema>;

export const searchResponseSchema = z.object({
  q: z.string(),
  total: z.number().int().nonnegative(),
  results: z.array(searchResultSchema),
});
export type SearchResponse = z.infer<typeof searchResponseSchema>;
